import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-recipe-card-finder-chart',
  standalone: false,
  templateUrl: './recipe-card-finder-chart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecipeCardFinderChartComponent {
}
